export const pathes = {
  DEFAULT: '/',
  BASE_PATH: '/vod-platform',
  ON_BOARDING: '/on-boarding',
  LOGIN_PHONE_NUMBER: '/login-phone-number',
  LOGIN_USERNAME: '/login-username',
  SIGNUP: '/signup',
  LOGIN_OTP: '/login-otp',
  SIGNUP_FORM: '/signup-form',
  CHANGE_NUMBER: '/change-number',
  CHANGE_NUMBER_OTP: '/change-number-otp',
  HOME: '/home',
  PROFILE: '/profile',
  WALLET: '/wallet',
  SETTING: '/setting',
  CHANGE_BACKGROUND: '/change-background',
  MY_GIFTS: '/my-gifts',
  QR_PAYMENT: '/qr-payment',
  PAYMENT_CODE: '/payment-code',
  PAYMENT: '/payment',
  SUCCESS_PAYMENT: '/success-payment',
  TRANSACTION_RECEIPT: '/transaction-receipt',
  FAQ: '/faq',
  ABOUT_SHAHRZAD: '/about-shahrzad',
  CASH_WITH_DRAWAL: '/cash-with-drawal',
  USER_LEVELS: '/user-levels',
  PRIVACY: '/privacy',
  CINEMA: '/festival-tickets',
  VIDEO_DETAIL: '/:mediaId',
}
